var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoldPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.56 12.56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16204"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16203"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10376",
    d: "M11.238 4.958H7.6V1.322a1.322 1.322 0 00-2.644 0v3.636H1.32a1.322 1.322 0 000 2.644h3.636v3.636a1.322 1.322 0 002.644 0V7.6h3.636a1.322 1.322 0 000-2.644z",
    fill: "inherit"
  })))));
}

export default SvgBoldPlus;